// src/services/VentaService.js
import axios from 'axios';
import { buildApiUrl } from '../config/api';

export const LeadService = {
    get: async ({ token, pagina = 1, pageSize = 20, desde, hasta, searchByName, state, list }) => {
        try {
            const response = await axios.get(buildApiUrl('/api/leads/'), {
                headers: { Authorization: `Bearer ${token}` },
                params: { pagina, pageSize, desde, hasta, searchByName, state, list },
            });

            return {
                leads: response.data.leads || [],
                totalPaginas: response.data.totalPaginas || 1,
                totalRegistros: response.data.totalRegistros || 0,
            };
        } catch (error) {
            console.error('Error en LeadService.get:', error);
            throw error;
        }
    },
    getById: async ({ token, vid }) => {
        try {
            const response = await axios.get(buildApiUrl(`/api/leads/${vid}`), {
                headers: { Authorization: `Bearer ${token}` },
            });

            return {
                lead: response.data.lead || {},
            };
        } catch (error) {
            console.error('Error en LeadService.getById:', error);
            throw error;
        }
    },
    save: async ({ token, formData }) => {
        const response = await axios.post(buildApiUrl('/api/leads'), formData, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },
    exportar: async (token, filtros) => {
        try {
            const response = await axios.post(buildApiUrl('/api/leads/exportar'), filtros, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });

            return response.data;
        } catch (error) {
            console.error('Error en lead.exportar', error);
            throw error;
        }
    },
    getStatistics: async ({ token, fechaInicio, fechaFin }) => {
        try {
            const url = buildApiUrl(`/api/leads/count`);

            const response = await axios.post(url, {
                fechaInicio: fechaInicio || null,
                fechaFin: fechaFin || null
            }, {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data;
        } catch (error) {
            console.error('Error en VentaService.getStatistics:', error);
            throw error;
        }
    },
    exportarReporteVentasExcel: async (token, filtros) => {
        try {
            const response = await axios.post(buildApiUrl('/api/ventas/exportarReporte'), filtros, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });

            return response.data;
        } catch (error) {
            console.error('Error en ExportacionService.exportarReporteVentasExcel:', error);
            throw error;
        }
    },
    fetchAvanceVentaPorId: async (token, id) => {
        try {
            const response = await axios.get(buildApiUrl(`/api/ventas-avances/${id}`), {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response || {};
        } catch (error) {
            console.error('Error en VentaService.fetchVentaPorId:', error);
            throw error;
        }
    },
    fetchVentasReporte: async ({ token, pagina = 1, pageSize = 20, desde, hasta, nombre, vendedores, estado, regiones }) => {
        try {
            const response = await axios.get(buildApiUrl('/api/ventas/reporte'), {
                headers: { Authorization: `Bearer ${token}` },
                params: { pagina, pageSize, desde, hasta, nombre, vendedores, regiones, estado },
            });

            return {
                ventas: response.data.ventas || [],
                totalPaginas: response.data.totalPaginas || 1,
                totalRegistros: response.data.totalRegistros || 0,
            };
        } catch (error) {
            console.error('Error en VentaService.fetchVentas:', error);
            throw error;
        }
    },
};
